define("settings/controllers/devices", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object/computed", "@ember/runloop", "@ember/service", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _computed, _runloop, _service, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let DevicesController = _exports.default = (_dec = (0, _computed.reads)('auth.currentUserModel'), _dec2 = (0, _computed.reads)('currentUserModel.postReviewEmailNotifications'), _dec3 = (0, _computed.reads)('currentUserModel.emailFollowUpNotifications'), _dec4 = (0, _computed.reads)('currentUserModel.highPerformingContentEmailNotifications'), _dec5 = (0, _computed.reads)('currentUserModel.isAccountOwner'), _dec6 = (0, _computed.reads)('currentUserModel.followUpPushNotifications'), _dec7 = (0, _computed.reads)('currentUserModel.highPerformingContentPushNotifications'), _dec8 = (0, _computed.reads)('currentUserModel.highPerformingCommentsEmailNotifications'), _dec9 = (0, _computed.reads)('currentUserModel.highPerformingCommentsPushNotifications'), _dec10 = (0, _computed.reads)('currentUserModel.postFailedToAutoPublishEmailNotifications'), _dec11 = (0, _computed.reads)('auth.currentAccount.canApprovalFlow'), (_class = class DevicesController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "currentUserModel", _descriptor5, this);
      _initializerDefineProperty(this, "postReviewEmailNotifications", _descriptor6, this);
      _initializerDefineProperty(this, "emailFollowUp", _descriptor7, this);
      _initializerDefineProperty(this, "highPerformingContentEmail", _descriptor8, this);
      _initializerDefineProperty(this, "isAccountOwner", _descriptor9, this);
      _initializerDefineProperty(this, "pushFollowUp", _descriptor10, this);
      _initializerDefineProperty(this, "highPerformingContentPushNotifications", _descriptor11, this);
      _initializerDefineProperty(this, "highPerformingCommentsEmail", _descriptor12, this);
      _initializerDefineProperty(this, "highPerformingCommentsPushNotifications", _descriptor13, this);
      _initializerDefineProperty(this, "postFailedToAutoPublishEmailNotifications", _descriptor14, this);
      _initializerDefineProperty(this, "showApprovalFlowEmailToggle", _descriptor15, this);
      _defineProperty(this, "disconnectDevice", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (device) {
          yield this.dialogManager.confirm(this.intl.t('shared_phrases.are_you_sure'), {
            description: this.intl.t('account.devices.disconnect_device.confirm_remove', {
              device_name: device.name
            })
          });
          if (this.model.length > 1 && this.isAccountOwner) {
            try {
              yield device.destroyRecord();
              this.alerts.success(this.intl.t('alerts.account.devices.disconnect_device.success.message'), {
                title: this.intl.t('alerts.account.devices.disconnect_device.success.title')
              });
            } catch (error) {
              this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
                title: this.intl.t('alerts.account.devices.disconnect_device.error.title')
              });
            }
          } else {
            if (this.isAccountOwner) {
              this.alerts.warning(this.intl.t('alerts.account.devices.disconnect_device.error_cannot.message'), {
                title: this.intl.t('alerts.account.devices.disconnect_device.error_cannot.title')
              });
            } else {
              this.alerts.warning(this.intl.t('alerts.account.devices.disconnect_device.error_cannot.message_not_owner'), {
                title: this.intl.t('alerts.account.devices.disconnect_device.error_cannot.title')
              });
            }
          }
        }
      }), null, "disconnectDevice", "drop"));
      _defineProperty(this, "togglePushNotifications", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('followUpPushNotifications', 'push_notification');
        }
      }), null, "togglePushNotifications", "drop"));
      _defineProperty(this, "toggleEmailNotifications", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('emailFollowUpNotifications', 'email_notification');
        }
      }), null, "toggleEmailNotifications", "drop"));
      _defineProperty(this, "toggleHighPerformanceEmails", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('highPerformingContentEmailNotifications', 'high_performing_email');
        }
      }), null, "toggleHighPerformanceEmails", "drop"));
      _defineProperty(this, "toggleHighPerformancePushNotifications", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('highPerformingContentPushNotifications', 'high_performing_push');
        }
      }), null, "toggleHighPerformancePushNotifications", "drop"));
      _defineProperty(this, "toggleHighPerformanceCommentsEmails", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('highPerformingCommentsEmailNotifications', 'high_performing_comment_email');
        }
      }), null, "toggleHighPerformanceCommentsEmails", "drop"));
      _defineProperty(this, "togglePostFailedToAutoPublishEmailNotifications", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('postFailedToAutoPublishEmailNotifications', 'post_failed_to_auto_publish_email');
        }
      }), null, "togglePostFailedToAutoPublishEmailNotifications", "drop"));
      _defineProperty(this, "toggleHighPerformanceCommentsPushNotifications", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('highPerformingCommentsPushNotifications', 'high_performing_comment_push');
        }
      }), null, "toggleHighPerformanceCommentsPushNotifications", "drop"));
      _defineProperty(this, "togglApprovalFlowSubmittedForReviewEmails", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.toggleNotificationPreference.perform('postReviewEmailNotifications', 'approval_flow_submitted_for_review_email');
        }
      }), null, "togglApprovalFlowSubmittedForReviewEmails", "drop"));
      _defineProperty(this, "toggleNotificationPreference", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (property, translationString) {
          const isEnabling = !this.currentUserModel[property];
          const messageStr = isEnabling ? 'message_enable' : 'message_disable';
          this.currentUserModel.toggleProperty(property);
          try {
            yield this.currentUserModel.save();
            const message = `alerts.account.devices.${translationString}.success.${messageStr}`;
            this.alerts.success(this.intl.t(message), {
              title: this.intl.t(`alerts.account.devices.${translationString}.success.title`),
              timeout: 15000
            });
          } catch (error) {
            (0, _runloop.later)(() => {
              this.currentUserModel.rollbackAttributes();
            }, 10);
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t(`alerts.account.devices.${translationString}.error.title`)
            });
          }
        }
      }), null, "toggleNotificationPreference", null));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentUserModel", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "postReviewEmailNotifications", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "emailFollowUp", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "highPerformingContentEmail", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isAccountOwner", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "pushFollowUp", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "highPerformingContentPushNotifications", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "highPerformingCommentsEmail", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "highPerformingCommentsPushNotifications", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "postFailedToAutoPublishEmailNotifications", [_dec10], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showApprovalFlowEmailToggle", [_dec11], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
});